export const SearchEmptyIcon = () => (
  <svg
    width="138"
    height="138"
    viewBox="0 0 138 138"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.3" cx="69" cy="69" r="69" fill="#D7D7D7" />
    <g clipPath="url(#clip0_8245_12448)">
      <path
        d="M56.7676 73.1914L48.5851 81.3741L48.2607 84.895H52.1059L58.6692 83.3908L60.2886 76.7123L56.7676 73.1914Z"
        fill="#D9D9D9"
      />
      <path
        d="M52.106 84.8936V88.6239L55.6274 88.4148L63.81 80.2322L60.2886 76.7109L52.106 84.8936Z"
        fill="#CACACA"
      />
      <path
        d="M80.2861 28C64.4278 28 51.572 40.8558 51.572 56.7141C51.572 64.6433 54.7859 71.8217 59.9822 77.018L88.8759 68L100.59 36.4102C95.3937 31.2139 88.2153 28 80.2861 28V28Z"
        fill="#D9D9D9"
      />
      <path
        d="M100.59 36.4102L59.9822 77.018C65.1784 82.2142 72.3569 85.4281 80.2861 85.4281C96.1444 85.4281 109 72.5723 109 56.7141C109 48.7848 105.786 41.6064 100.59 36.4102Z"
        fill="#CACACA"
      />
      <path
        d="M80.2859 37.957C69.9453 37.957 61.5312 46.3711 61.5312 56.7133C61.5312 61.8836 63.6348 66.5722 67.0309 69.9683L88.1081 63.8123L93.5425 43.4567C90.1461 40.0605 85.457 37.957 80.2859 37.957Z"
        fill="#EBEBEB"
      />
      <path
        d="M67.0308 69.9686C70.4269 73.3647 75.1156 75.4683 80.2858 75.4681C90.6279 75.4681 99.042 67.0541 99.042 56.7134C99.042 51.5423 96.9384 46.8533 93.5422 43.457L67.0308 69.9686Z"
        fill="#E0E0E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.7789 85.6465L45.8179 78.6074L48.5851 81.373L52.1059 84.894L51.7303 91.5577L45.066 91.9338L45.065 91.9337L45.066 91.9347L42.4142 102.17L31.6049 105.396C28.1317 101.924 28.1317 96.2944 31.6051 92.8209L38.7787 85.6474L38.779 85.6476L38.7789 85.6465Z"
        fill="#D0D0D0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.3944 91.1814L51.3537 98.222L51.3536 98.222L51.3537 98.2221L44.1801 105.396C42.4442 107.132 40.1676 108 37.8926 108C35.6161 108 33.3411 107.132 31.6051 105.396C31.6051 105.396 31.6051 105.396 31.6051 105.396C31.6051 105.396 31.605 105.396 31.605 105.396L45.0659 91.9346L45.0659 91.9344L52.1058 84.8945L55.6272 88.4158L58.3944 91.1814Z"
        fill="#B8B8B8"
      />
      <path
        d="M83.9103 49.7754L80.2862 53.3995L76.6622 49.7754L73.3477 53.0899L76.9717 56.714L73.3477 60.338L75.005 61.9952L85.5675 51.4327L83.9103 49.7754Z"
        fill="#D0D0D0"
      />
      <path
        d="M87.2247 53.0908L85.5674 51.4336L75.0049 61.9961L76.6621 63.6534L80.2861 60.0294L83.9102 63.6534L87.2247 60.3389L83.6007 56.7148L87.2247 53.0908Z"
        fill="#B8B8B8"
      />
    </g>
    <defs>
      <clipPath id="clip0_8245_12448">
        <rect
          width="80"
          height="80"
          fill="white"
          transform="translate(29 28)"
        />
      </clipPath>
    </defs>
  </svg>
)
